var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('AccountBreadcrumbRoute',_vm._b({},'AccountBreadcrumbRoute',{ title: _vm.title },false))],1),_c('div',{staticClass:"column is-12"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }